<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
ib-dialog(v-model="show", id="comp-dialog", :width="$media.l ? '75%' : '98%'")
    template(slot="header")
        h2.ib-col.insetx-32.insety-16 {{ $t('company_search') }}
            span(class="float-right fs4" @click="close")
                +icon-basic-cancel_filled
    template(slot="default")
        div(class="offset-xl1 offset-l1 offset-m1 xl10 l10 m10 s11 small-table", :class="{'outsety-24': !$media.s}")
            p {{ $t('use_search_form') }}  {{ $t('then_check_add') }}
             b  {{ $t('add_max_companies') }}
            ib-form(class="ticker flex-flex outsety-16")
                ib-field(
                    v-model="curSearch",
                    class="ticker-field mb50",
                    :placeholder="$t('ticker_company')",
                    uppercase=true,
                    width="100%",
                    autofocus=true
                )
                span(@click="clearTicker", class="bg15-inverse cancel")
                    +icon-basic-cancel
                button(@click="getComp(false)", class="magnify")
                    +icon-basic-search_filled
            div(v-if="total > 0 || total === -1", class="insety-4")
                h3 {{ $t('company_results') }}: "{{previousSearch}}"
                div(class="border-bottom bg-gray100")
                ib-infobox(v-if="total === -1", tone="error", class="outsety-16") No companies found.
                ib-table-basic(v-if="searchResults.length > 0", spacing="compact", :data="searchResults", class="outsety-16 border")
                    ib-table-col(v-if="!$media.l", width="4ch")
                    ib-table-col(v-else, width="6ch")
                    ib-table-col(v-if="$media.l", width="12ch") {{ $t('symbol') }}
                    ib-table-col {{ $t('name') }}
                    ib-table-col {{ $t('type') }}
                    template(slot="body", slot-scope="comp")
                        td(class="ticker-remove")
                            span(
                                v-if="comp._added", 
                                class="fg-add",
                                :class="{'insetx-8' : $media.l}"
                            )
                                +icon-basic-checked
                            span(   
                                v-else, 
                                @click="addTicker(comp)", 
                                class="fg-add hover-black",
                                :class="{'insetx-8' : $media.l}"
                            )
                                +icon-basic-plus_filled
                        td(v-if="$media.l")
                            span {{ comp.ticker }}
                        td(v-text="formatComp(comp.name)", :class="{'fs8' : !$media.l}")
                        td(v-if="comp.type === 'stocks'")
                            span {{ $t('stock') }}
                        td(v-else-if="comp.type === 'etfs'")
                            span {{ $t('etf') }}
                div(v-if="searchResults.length > 0", class="fixed-fixed after-16")
                    ib-dropdown(
                        :data="dropdownData",
                        v-model="numShow",
                        :placeholder="$t('show_rows')",
                        @change="changeShown",
                        align="center",
                        :class="{'fullWidth' : !$media.l}"
                    )
                    div(class="flex-fixed", :class="{ 'pagination-small': !$media.l }")
                        span {{ $t('page') }}
                        ib-field(:disabled="totalPages <= 1", width="5ch", align="center", placeholder=1, class="outsetx-8", v-model="page", @change="changePage")
                        span {{ $t('of') }}
                            strong(style="margin-left:4px;") {{ totalPages }}
                        div(class="outsetx-16", style="align-self: center;")
                            ib-button(:disabled="page <= 1", @click="changePage(--page)", class="page-btn")
                                +icon-arrow-back
                            ib-button(:disabled="page >= totalPages", @click="changePage(++page)", class="page-btn")
                                +icon-arrow-forward
            div(v-if="selectedCompanies.length > 0", class="border-top")
                h3(class="before-16") {{ $t('selected_companies') }}
                div(class="border-bottom bg-gray100")
                ib-table-basic(spacing="compact", :data="selectedCompanies", class="outsety-16 border")
                    ib-table-col(v-if="!$media.l", width="4ch")
                    ib-table-col(v-else, width="6ch")
                    ib-table-col(v-if="$media.l", width="12ch") {{ $t('symbol') }}
                    ib-table-col {{ $t('name') }}
                    ib-table-col {{  $t('type') }}
                    template(slot="body", slot-scope="comp")
                        td(class="ticker-remove")
                            span(
                                @click="removeTicker(comp)", 
                                class="fg-remove hover-black", 
                                :class="{'insetx-8' : $media.l}"
                            )
                                +icon-basic-cancel
                        td(v-if="$media.l")
                            span {{ comp.ticker }}
                        td(v-text="formatComp(comp.name)", :class="{'fs8' : !$media.l}")
                        td(v-if="comp.type === 'stocks'")
                            span {{ $t('stock') }}
                        td(v-else-if="comp.type === 'etfs'")
                            span {{ $t('etf') }}
    template(slot="footer")
        div(class="fullWidth fixed-fixed")
            ib-button(
                :disabled="selectedCompanies.length === 0",
                @click="cancelData",
                class="cancelled outsety-8 text-center",
                :class="{ fullWidth: !$media.xl, 'outsety-8': !$media.xl }",
            ) {{ $t('reset') }}
            ib-button(
                @click="addData",
                class="added outsety-8 text-center",
                :class="{ fullWidth: !$media.xl, 'outsety-8': !$media.xl }",
                :disabled="selectedCompanies.length === 0",
                tone="accent",
            ) {{ $t('apply') }}
</template>

<script>

    import api from '../api/';
    import { formatMixin } from '../js/formatting.js';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'EditCompanies',
        data() {
            return {
                selectedCompanies: [], // Companies selected in modal
                searchResults: [],
                numShow: 'Show 10 Rows',
                page: 1,
                curSearch: '',
                previousSearch: '',
                total: 0,
                show: false,
            }
        },
        mixins: [formatMixin],
        methods: {
            addData() {
                for (let i = 0; i < this.selectedCompanies.length; i++) {
                    let comp = this.selectedCompanies[i];
                    delete comp._added;
                    Vue.set(comp, 'selected', true);
                    Vue.set(this.selectedCompanies, i, comp);
                }
                this.$emit('update', this.selectedCompanies);
                this.close();
            },
            cancelData() {
                this.selectedCompanies = [];
                this.searchResults = [];
                this.previousSearch = '';
                this.curSearch = '';
                this.total = 0;
                this.$emit('update', this.selectedCompanies);
                this.clearTicker();
                this.close();
            },
            clearTicker() {
                this.curSearch = "";
            },
            close() {
                this.clearTicker();
                this.searchResults = [];
                this.previousSearch = '';
                this.curSearch = '';
                this.total = 0;
                this.show = false;
            },
            open(companies) {
                this.selectedCompanies = companies;
                this.show = true;
            },
            getComp(paging) {
                if (this.curSearch.length === 0 && !paging) {
                    return;
                }
                if (this.selectedCompanies.length > 24) {
                    this.$alert(this.$t('only_add_25_comps'));
                    this.curSearch = '';
                } else {
                    let limit = this.numShow.split(' ')[1];
                    if (!limit) limit = 10;

                    if (!paging) this.page = 1;

                    const options = {
                        limit,
                        'page': this.page
                    };

                    const searchTerm = paging ? this.previousSearch : this.curSearch;
                    // console.debug({paging}, {searchTerm});
                    api.getCompanies(searchTerm, options, 'all')
                            .then((res) => {
                                if (!res || !res.res || !res.res.length) {
                                    this.searchResults = [];
                                    this.total = -1;
                                    this.previousSearch = this.curSearch;
                                    this.curSearch = '';
                                    // No results. Display error message...
                                    return;
                                } else {
                                    const results = res.res;
                                    this.total = res.res.length;
                                    // To quickly check if we have that company ticker already selected
                                    const tickerMap = new Map();
                                    this.selectedCompanies.forEach(comp => {
                                        tickerMap.set(comp.ticker, 1);
                                    })

                                    // If we already have it selected, add property _added to company to display check & disallow user adding again
                                    const alteredResults = results.map((comp) => {
                                        if (tickerMap.get(comp.ticker)) {
                                            const alteredComp = comp;
                                            comp._added = true;
                                            return alteredComp;
                                        }
                                        return comp;
                                    });

                                    this.searchResults = alteredResults;
                                    if (!paging) {
                                        this.previousSearch = this.curSearch; // Used for pagination since we clear text of input & curSearch is v-model
                                        this.curSearch = '';
                                    }
                                }
                            })
                            .catch(error => {
                                console.error(error);
                                this.curSearch = '';
                                this.total = -1;
                            })
                }
            },
            addTicker(comp) {
                if (this.selectedCompanies.length > 25) {
                    this.$alert(this.$t('can_only_have_25'));
                    return;
                }

                const compIndex = this.selectedCompanies.indexOf(comp);
                if (compIndex !== -1) return;

                comp._added = true;
                // You can't just push because *somehow* this affects the data on select components even though this isn't linked
                this.selectedCompanies = [...this.selectedCompanies, comp];

                let newAssets = [];
                if (comp.type === 'stocks') {
                    newAssets = [{ name: 'stocks', selected: true }, { name: 'etfs', selected: false }]
                } else if (comp.type === 'etfs'){
                    newAssets = [{ name: 'stocks', selected: false }, { name: 'etfs', selected: true }]
                }
                this.setAssets(newAssets);
            },
            removeTicker(comp) {
                let compIndex = this.selectedCompanies.indexOf(comp);
                if (compIndex === -1) return;
                
                const shallowCopy = this.selectedCompanies.slice();
                shallowCopy.splice(this.selectedCompanies.indexOf(comp), 1);

                this.selectedCompanies = shallowCopy;
                // this.selectedCompanies.splice(this.selectedCompanies.indexOf(comp), 1);
                // Uncheck from search results if there & a new search/pagination occured
                compIndex = this.searchResults.findIndex(i => {
                    return i.id === comp.id;
                })

                if (compIndex !== -1) {
                    this.searchResults[compIndex]._added = false;
                }
            },
            changePage(value) {
                if (isNaN(value)) return;
                if (value > this.totalPages || value < 1) return;

                this.page = value;
                this.getComp(true);
            },
            /**
             * If user changes amount shown, we will start them back on page 1
             */
            changeShown() {
                this.page = 1;
                this.getComp(true);
            },
            ...mapActions(['setAssets'])
        },
        computed: {
            totalPages() {
                return parseInt((this.total / this.numShow.split(' ')[1])+ 1);
            },
            dropdownData() {
                return ['10','25','50','100'].map(text => this.$t('show') + " "+ text + " " + this.$t('rows'))
            }
        }
    }
</script>

<style lang="less" scoped>
#comp-dialog {
    max-width: 700px!!important;
    border-top: 5px solid #0B56BF;
    .small-table {
        padding-top: 16px;
    }
    .ticker {
        .ticker-field {
            margin-right: 0;
            &:hover {
                border-color: #000;
            }
        }
        .cancel {
            padding: 4px;
            border: 1px solid #d7d7d7;
            border-radius: 0;
            svg {
                color: #dcdcde;
            }
        }
        .magnify {
            height: 31px;
            margin: 0;
            border: 1px solid #D7D7D7;
            border-radius: 0 5px 5px 0px;
            background-color: #F7F7F7;
            position: relative;
            top: 2px;
            svg {
                width: 1em;
                height: 1em;
                vertical-align: sub;
            }
        }
    }
    button {
        border-radius: 0;
        &.cancelled {
            &:hover {
                border-color: #000;
                background-color: #fff;
            }
            &::after {
                background-color: #fff;
                opacity: 0;
            }
        }
        &.added {
            &:hover {
                border-color: #000;
                background: #000;
            }
        }
    }
    ._dlgi {
        display: block;
    }
}

@media (max-width: 892px) {
    #comp-dialog {
        .ticker {
            .magnify {
                top: 3px;
            }
        }
    }
}
@media (max-width:600px) {
    #comp-dialog {
        max-width: 98% !important;
        .small-table {
            margin: auto;
        }
        h2 {
            font-size: 1.4rem;
        }
        h3 {
            font-size: 1rem;
        }
        .ticker-remove {
            padding-inline-start: 8px;
        }
    }
    div {
        .search-button {
            &.mt-0 {
                margin-right: 16px;
                margin-left: 16px;
                text-align: left;
            }
        }
    }
}

.page-btn {
    margin: 0px 4px 0;
    padding: 3px;
    width: 26px;
    border: 1px solid transparent;
    border-radius: 0;
    color: #666;
    background-color: #fcfcfc;
    border-color: #d7d7d7;
    box-shadow: none;
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 400;
    text-align: center;

    &:hover {
        color: #000;
        border-color: #000;
    }
}

.pagination-small {
    margin: auto;
    margin-top: 8px;
}

.hover-black {
    &:hover {
        color: #000;
    }
}
</style>